import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"


export const getAllFeedbackOfStudent = id => get(url.GET_ALL_FEEDBACK_OF_STUDENT + id);
export const saveFeedbackResponse = data => post(url.SAVE_FEEDBACK_RESPONSE, data);
